import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { BaseHttpService } from './base-http.service';
import { Company } from '../models/company';

import { Observable } from 'rxjs/Observable';
import { ServiceLocator } from '../helpers/service-locator';
import { CompanyLicenseType } from '../models/company-license-type';
import { Country } from '../models/country';
import { ContactType } from '../models/contact-type';
import { CompanyContact } from '../models/company-contact';
import { CompanyContactAdd } from '../models/company-contact-add';
import { Lookup } from '../models';
import { CompanyBuildingUnitAdd } from '../models/company-building-unit-add';
import { CompanyRequestsReport } from '../models/company-requests-report';

@Injectable()
export class TenantService extends BaseHttpService<Company> {
  constructor(private http: HttpClient) {
    super('tenants');
  }

  getMyCompany(): Observable<Company[]> {

    return this.http
      .get(this.getApiURI() + '/tenants/GetMyPendingTenant')
      .catch(this.handleError)
  }

  addCompanyContact(entity: CompanyContactAdd): Observable<CompanyContactAdd> {
    return this.http
      .post(this.getApiURI() + "/tenants/AddCompanyContact", JSON.stringify(entity))
      .catch(this.handleError);

  }

  addCompanyBuilding(entity: CompanyBuildingUnitAdd): Observable<CompanyBuildingUnitAdd> {
    return this.http
      .post(this.getApiURI() + "/tenants/AddCompanyBuilding", JSON.stringify(entity))
      .catch(this.handleError);

  }
  deleteCompanyContact(companyId: number, contactId: number) {
    return this.http
      .delete(this.getApiURI() + `/tenants/${companyId}/contacts/${contactId}`)
      .catch(this.handleError);
  }
  deleteCompanyBuildingUnit(companyId: number, companyBuildingUnitId: number) {
    return this.http
      .delete(this.getApiURI() + `/tenants/${companyId}/buildingunits/${companyBuildingUnitId}`)
      .catch(this.handleError);
  }


  approveCompany(id: number, entity: Company): Observable<Company> {
    return this.http
      .put(this.getApiURI() + `/tenants/${id}/ApproveCompany`, JSON.stringify(entity))
      .catch(this.handleError);
  }
  SubmitCompany(id: number, entity: Company): Observable<Company> {
    return this.http
      .put(this.getApiURI() + `/tenants/${id}/SubmitCompany`, JSON.stringify(entity))
      .catch(this.handleError);
  }

  getTenantsLookup(): Observable<Lookup[]> {

    return this.http
      .get(this.getApiURI() + "/tenants/GetTenantsLookup")
      .catch(this.handleError)
  }

  getMyCompanyProfile(): Observable<Company> {
    return this.http
      .get(this.getApiURI() + '/tenants/GetMyCompanyProfile')
      .catch(this.handleError)
  }

  getPendingTenants(): Observable<Company[]> {

    return this.http
      .get(this.getApiURI() + '/tenants/GetPendingTenants')
      .catch(this.handleError)
  }

  replaceLicenseeManager(id: number, entity: Company): Observable<Company> {
    return this.http
      .put(this.getApiURI() + `/tenants/${id}/ReplaceLicenseeManager`, JSON.stringify(entity))
      .catch(this.handleError);

  }

  resendInvitation(entity: Company): Observable<any> {
    return this.http
      .post(this.getApiURI() + `/tenants/${entity.id}/ResendInvitation`, null)
      .catch(this.handleError);
  }

  getTenantsDirectory(): Observable<Company[]> {

    return this.http
      .get(this.getApiURI() + '/tenants/GetTenantsDirectory')
      .catch(this.handleError)
  }
  getTenantsRequestsReport(model: { fromDate: Date, toDate: Date, textSearchString: string }): Observable<CompanyRequestsReport[]> {
    var fromDate = (model.fromDate == null ? null : model.fromDate.toUTCString());
    var toDate = (model.toDate == null ? null : model.toDate.toUTCString());
    return this.http
      .get(this.getApiURI() + '/tenants/GetTenantsRequestsReport'
      + `?fromDate=${fromDate}&toDate=${toDate}&textSearchString=${model.textSearchString}`)
      .catch(this.handleError)
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/tenant.service.ts